<script>
import Layout from '@/router/layouts/main';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import Repositories from '@/repositories';
const VersionsRepository = Repositories.get('versions');
import dateMixin from '@/mixins/dateMixin';

/**
 * Dashboard Component
 */
export default {
  page: {
    title: 'Categories',
  },
  mixins: [dateMixin],
  components: {
    Layout,
    Loading,
  },
  data() {
    return {
      isLoading: false,
      items: [
        {
          text: 'versions',
          href: '/versions',
        },
        {
          text: '',
          active: true,
        },
      ],
      versions: null,
    };
  },
  created() {
    this.loadData();
  },
  methods: {
    loadData() {
      this.isLoading = true;
      let promise1 = VersionsRepository.getAll().then((response) => {
        this.versions = response.data;
      });

      Promise.all([promise1])
        .then(() => {
          this.isLoading = false;
        })
        .catch(() => {
          this.isLoading = false;
          this.$toast.errorToast(this.$t('errors.errorLoading'));
        });
    },
  },
};
</script>

<template>
  <Layout :title="$t('versions.versions')">
    <loading
      :active.sync="isLoading"
      :can-cancel="false"
      color="#f1b44c"
      :width="70"
      :height="70"
      loader="dots"
      :is-full-page="false"
    >
    </loading>

    <div v-if="versions != null">
      <b-card-group deck>
        <b-card :header="$t('inventory.inventory')">
          <b-list-group>
            <b-list-group-item
              class="d-flex justify-content-between align-items-center"
            >
              Version
              <b-badge style="font-size: 1em" variant="primary">{{
                versions.version
              }}</b-badge>
            </b-list-group-item>
            <b-list-group-item
              class="d-flex justify-content-between align-items-center"
            >
              Commit
              <b-badge style="font-size: 1em" variant="primary">{{
                versions.commitHash
              }}</b-badge>
            </b-list-group-item>
            <b-list-group-item
              class="d-flex justify-content-between align-items-center"
            >
              Date
              <b-badge style="font-size: 1em" variant="primary">{{
                formatDateTime(versions.commitDate)
              }}</b-badge>
            </b-list-group-item>
            <b-list-group-item
              class="d-flex justify-content-between align-items-center"
            >
              {{ $t('versions.migrationDone') }}
              <b-badge
                style="font-size: 1em"
                :variant="versions.migrationsPending ? 'danger' : 'success'"
              >
                {{ versions.migrationsPending == false }}
              </b-badge>
            </b-list-group-item>
          </b-list-group>
        </b-card>

        <b-card header="Main">
          <b-list-group>
            <b-list-group-item
              class="d-flex justify-content-between align-items-center"
            >
              Version
              <b-badge style="font-size: 1em" variant="primary">
                {{ versions.mainVersion }}
              </b-badge>
            </b-list-group-item>
            <b-list-group-item
              class="d-flex justify-content-between align-items-center"
            >
              Commit
              <b-badge style="font-size: 1em" variant="primary">
                {{ versions.mainCommitHash }}
              </b-badge>
            </b-list-group-item>
            <b-list-group-item
              class="d-flex justify-content-between align-items-center"
            >
              Date
              <b-badge style="font-size: 1em" variant="primary">
                {{ formatDateTime(versions.mainCommitDate) }}
              </b-badge>
            </b-list-group-item>
            <b-list-group-item
              class="d-flex justify-content-between align-items-center"
            >
              {{ $t('versions.migrationDone') }}
              <b-badge
                style="font-size: 1em"
                :variant="versions.mainMigrationsPending ? 'danger' : 'success'"
              >
                {{ versions.mainMigrationsPending == false }}
              </b-badge>
            </b-list-group-item>
          </b-list-group>
        </b-card>
      </b-card-group>
    </div>
  </Layout>
</template>
